import React from 'react'
import LayoutModal from '../../organisms/layoutModal/layout-modal'
import logoWhathsapp from '../../../assets/images/whatsapp-icon.png'
import logoFacebook from '../../../assets/images/facebook.svg'
import { pushDataLayerEvent } from '../../../utils/metricManagementUtil'
import { dataLayerUserInfo } from '../../../utils/userInfo'
import './modal-share.scss'

const ModalShare = ({ hideAction }) => {

    const userInf=dataLayerUserInfo()
    const dataLaterShare = (label) => {
		
        
		let location=''
		if (typeof window !== 'undefined') {
			location= window.location.href
		}
		pushDataLayerEvent({event: 'Interacciones - Pop-ups',
		category: 'pop-up',
		action: 'click',
		label,
		location,
		user_data: userInf.user_data? userInf.user_data: '',
		log_status: userInf.log_status,})

		pushDataLayerEvent({
			event: 'share',
			method: label
		})
	}

	return (
		<LayoutModal>
			<div className='f-modal-share'>
				<div className='f-card-modal-head'>
					<span className='f-card-modal-head-icon' onClick={hideAction}>
						X
					</span>
				</div>
				<h3 className='f-modal-share-title'>
					Comparte nuestro contenido <span>TENA</span> , con tus familiares y
					amigos.
				</h3>
				<p className='f-modal-share-copy'>
					Selecciona la red social en la que quieres compartir este video:
				</p>
				<div>
					<a
						className='f-modal-share__btn f-whatsapp-icon'
						href={`https://wa.me/?text=Me+gustar%C3%ADa+que+vieras+este+evento+de+TENA%2C+${window.location.href}`}
						target='_blank'
						onClick={() => {
							dataLaterShare('WhatsApp')
						}}
						rel='noreferrer'
					>
						<img src={logoWhathsapp} />
					</a>
					<a
						className='f-modal-share__btn'
						href={`https://www.facebook.com/sharer/sharer.php?u=${window.location.href}`}
						target='_blank'
						onClick={() => {
							dataLaterShare('Facebook')
						}}
						rel='noreferrer'
					>
						<img src={logoFacebook} />
					</a>
				</div>
				{/* <button
                    type="button"
                    className="f-modal-share__button"
                    onClick={hideAction}
                >
                    COMPARTIR
                </button> */}
			</div>
		</LayoutModal>
	)
}

export default ModalShare
